import { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/dist/types/types';

export interface LeadStatusItem {
  id: string;
  value: string;
  order_key: number;
  is_custom: boolean;
  isLocked: boolean;
  color?: string;
}

const statusDataKey = Symbol('status');

type StatusData = { [statusDataKey]: true; statusId: LeadStatusItem['id'] };

export type StatusDragState =
  | { type: 'idle' }
  | { type: 'preview'; container: HTMLElement }
  | { type: 'is-dragging' }
  | { type: 'is-dragging-over'; closestEdge: Edge | null };

export const getStatusData = (status: LeadStatusItem): StatusData => ({
  [statusDataKey]: true,
  statusId: status.id
});

export const isStatusData = (
  data: Record<string | symbol, unknown>
): data is StatusData => data[statusDataKey] === true;
